export const Web3TxHash = "web3::tx_hash";
export const Web3TxHashError = "web3::tx_hash/error";
